<template lang="pug">
.container-login
  .login
    .header-login
      img(class="logo" src="@/assets/logo.webp" alt="Marca da empresa Nexa Skills" class="logo")
      h2 Entre na sua Nexa Page <strong className="text-nexa_lime">_</strong>
      p Faça seu cadastro e descubra todas as vantagens de ser um <strong>Nexa</strong> User!
    .login-form(
      @keyup.enter="acessarConta"
      @submit.prevent="acessarConta"
    )
      EffectInput(
        v-model="email"
        type="email"
        placeholder="nexanouserm@nexa.com"
        label="Email"
      )
      .email-error(v-if="emailError")
        p {{ emailError }}
      .password-field
        EffectInput(
          v-model="senha"
          :type="showPassword ? 'text' : 'password'"
          placeholder="Digite sua senha"
          label="Senha"
        )
        .password-toggle(@click="togglePasswordVisibility")
          LucideIcon(:name="showPassword ? 'EyeOff' : 'Eye'" :size="16")
      div
        Button(
          variant="borderless"
          width="100%"
          class="btn-gradient-hover"
          :class="[ !isFormValid && 'disabled' ]"
          :disabled="!isFormValid"
          @click.prevent="acessarConta"
          type="button"
        ) 
          template(v-if="isLoading") Entrando...
          template(v-else)
            | Entrar 
            img.img-right(src="@/assets/icons/arrow_right.svg")
        BottomGradient
      div
        BorderGradient
      .social-login
        div
          Button(
            variant="borderless"
            width="100%"
            class="btn-gradient-hover positionTextLeft"
            fontSize="14px"
            color="#d4d4d4"
            @click="$router.push('/login')"
          ) 
            <img class="img-left" src="@/assets/icons/brand_github.svg" />
            | GitHub
          BottomGradient
        div
          Button(
            variant="borderless"
            width="100%"
            class="btn-gradient-hover positionTextLeft"
            fontSize="14px"
            color="#d4d4d4"
            @click="$router.push('/login')"
          ) 
            <img class="img-left" src="@/assets/icons/brand_google.svg" />
            | Google
          BottomGradient
    .vem-ser-nexa
      h2 Ainda não é um nexa, vem ja ser um! 
        Link(
          href="/cadastrar"
          color="$corPrimary"
          :underline="true"
          text="Ser Nexa"
        )

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EffectInput from '@/components/ui/EffectInput.vue'
import Button from '@/components/ui/Button.vue'
import BottomGradient from '@/components/ui/BottomGradient.vue'
import BorderGradient from '@/components/ui/BorderGradient.vue'
import Link from '@/components/ui/Link.vue'
import LucideIcon from '@/components/LucideIcon.vue'
import MessageMixin from '@/mixins/MessageMixin.js'

export default {
  mixins: [MessageMixin],
  
  components: {
    EffectInput,
    Button,
    BottomGradient,
    BorderGradient,
    Link,
    LucideIcon,
  },

  data() {
    return {
      hoverLoginEmail: false,
      hoverLoginGoogle: false,
      hoverLoginGithub: false,
      email: '',
      senha: '',
      showPassword: false
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'auth/isLoading',
      authError: 'auth/getError'
    }),

    emailError() {
      if (!this.email) return null
      
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(this.email)) {
        return 'Digite um email válido'
      }
      return null
    },

    isFormValid() {
      return this.email.trim() !== '' && 
             this.emailError === null && 
             this.senha.trim() !== '' && 
             !this.isLoading
    }
  },

  mounted() {
    // Verifica se foi redirecionado por sessão expirada
    if (sessionStorage.getItem('auth_expired') === 'true') {
      sessionStorage.removeItem('auth_expired')
      this.showWarningMessage('Seu token de autenticação expirou. Por favor, faça login novamente.')
    }
  },

  methods: {
    ...mapActions({
      getLogin: 'auth/login',
    }),

    togglePasswordVisibility() {
      this.showPassword = !this.showPassword
    },

    async acessarConta(event){
      // Previne comportamento padrão do formulário
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }

      // Validação antes de enviar
      if (!this.isFormValid) {
        let message = 'Por favor, corrija os seguintes problemas:'
        if (this.emailError) message += `\n• ${this.emailError}`
        if (!this.email.trim()) message += '\n• Email é obrigatório'
        if (!this.senha.trim()) message += '\n• Senha é obrigatória'
        
        this.showWarningMessage('Por favor, preencha todos os campos corretamente')
        return false
      }

      try {
        const loginData = {
          username: this.email,
          password: this.senha
        }
        
        const result = await this.getLogin(loginData)
        
        if (result.success) {
          this.showSuccessMessage('Login realizado com sucesso!')
          
          // Redireciona para o perfil após sucesso
          this.$router.push('/espaco-nexa/perfil')
        } else {
          // Erro da API - exibe mensagem específica retornada
          const errorMessage = result.error || result.message || 'Email ou senha inválidos'
          this.showErrorMessage(errorMessage)
          // Limpa apenas a senha para permitir nova tentativa
          this.senha = ''
        }
      } catch (error) {
        // Erro inesperado - exibe mensagem específica se disponível
        let errorMessage = 'Erro inesperado ao fazer login. Tente novamente.'
        
        // Tenta extrair mensagem específica do erro
        if (error.response?.data?.message) {
          errorMessage = error.response.data.message
        } else if (error.message) {
          errorMessage = error.message
        } else if (typeof error === 'string') {
          errorMessage = error
        } else if (error.type === 'network_error') {
          errorMessage = 'Erro de conexão com o servidor. Verifique sua internet.'
        } else if (error.type === 'response_error') {
          errorMessage = error.message || `Erro ${error.status}: ${error.data?.message || 'Erro no servidor'}`
        }
        
        this.showErrorMessage(errorMessage)
        console.error('Erro no login:', error)
        // Limpa apenas a senha para permitir nova tentativa
        this.senha = ''
      }
      
      return false
    }
  }
}
</script>

<style lang="scss">
.container-login{
  width: 100%;
  height: 100%;
  position: relative;

  .login{
    width: 450px;
    margin: 0 auto;
    background: $corPreto;
    border-radius: 16px;
    padding: 32px;
    box-sizing: border-box;
    color: $corBranco;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .header-login{
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      
      img.logo{
        width: 290px;
        margin-bottom: 32px;
      }
    }

    h2{
      display: block;
      width: 100%;
      font-size: 20px;
      margin: 0 0 12px 0;
      padding: 0;
      text-align: left;
      color: $corCinzaClaro;

      strong{
        margin-left: -10px;
        color: $corPrimary;
      }
    }
    p{
      width: 100%;
      font-size: 14px;
      margin: 0;
      padding: 0;
      text-align: left;
      line-height: 18px;
      color: $corCinzaEscuro;
    }

    .login-form{
      width: 100%;
      margin: 32px 0;

      .email-error {
        margin-top: -16px;
        margin-bottom: 16px;
        
        p {
          color: #ef4444;
          font-size: 12px;
          margin: 0;
          padding: 0;
          text-align: left;
          line-height: 14px;
        }
      }

      .password-field {
        position: relative;
        margin-bottom: 20px;

        .password-toggle {
          position: absolute;
          right: 12px;
          top: 47%;
          cursor: pointer;
          color: #a3a3a3;
          transition: color 0.2s ease;
          z-index: 10;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;

          &:hover {
            color: $corPrimary;
          }
        }

        span {
          margin-bottom: 0;
        }
      }

      .social-login{
        display: flex;
        flex-direction: column;
        gap: 20px;
        color: $corCinzaEscuro;
        font-size: 14px;

        img{
          width: 16px;
          margin-top: 0;
        }
      }

      .btn-gradient-hover.disabled {
        opacity: 0.4 !important;
        cursor: not-allowed !important;
        
        &:hover {
          opacity: 0.4 !important;
        }
        
        // Mantém o estilo original do botão
        background: transparent !important;
        border: none !important;
      }
    }
    .vem-ser-nexa{
      width: 100%;
      text-align: left;
      h2{
        color: $corBrancoClaro;
        font-size: 16px;
        margin-bottom: 0;
        font-weight: 500;
      }
    }

  }
  @media screen and (max-width: 600px) {
    background: $corPreto;
    height: 100%;

    .login{
      width: 100%;
      padding: 16px;

      .header-login{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        img.logo{
          width: 200px;
        }
      }
  
      h2{
        font-size: 18px;
        margin-bottom: 10px;
      }
  
      .vem-ser-nexa{
        h2{
          font-size: 14px;
          
          .vue-link{
            font-size: 14px !important;
          }
        }
      }
    }

    body:has(input:focus) .login {
      position: static !important;
      transform: none !important;
      top: auto !important;
      left: auto !important;
    }
  }
}

@media screen and (max-width: 600px) {
  body:has(input:focus) .login {
    position: static !important;
    transform: none !important;
    top: auto !important;
    left: auto !important;
  }
}
</style>